import getInfo from './getInfo';

const checkFileCreation = () =>
  new Promise((resolve, reject) => {
    if (document.getElementById('like-water')) {
      resolve(
        fetch(
          getInfo().json
          // getInfo().json.replace(
          //   'https://raw.githubusercontent.com/',
          //   'https://gitcdn.xyz/repo/'
          // )
        ).then(response => response.json())
      );
    } else {
      const e = document.createElement('aside');
      e.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-triangle"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12" y2="17"></line></svg>' +
        'create file, enter path:';
      const inp = document.createElement('input');

      inp.onchange = event => {
        const b = document.createElement('div');
        b.id = 'like-water';

        b.setAttribute('data-file', getInfo(event.target.value).json);

        document.body.appendChild(b);
        e.remove();
        resolve({ blocks: [] });
      };

      e.classList.add('_alert');

      e.appendChild(inp);
      document.body.prepend(e);
    }
  });

export default checkFileCreation;
